import { useChainsSorting } from 'modules/chains/hooks/useChainsSorting';
import { usePublicChainsCheckbox } from 'domains/chains/components/PublicChainsCheckbox/usePublicChainsCheckbox';

import { useChainsPublicStats } from './useChainsPublicStats';
import { usePublicChainsList } from './usePublicChainsList';

export const usePublicChains = () => {
  const {
    chains,
    loading: chainsLoading,
    searchContent,
    setSearchContent,
    setSortType,
    sortType,
    timeframe,
  } = usePublicChainsList();

  const {
    isChecked: isPublicChainsChecked,
    onClick: onPublicChainsCheckboxClick,
  } = usePublicChainsCheckbox();

  const {
    chainsCountsMap,
    loading: statsLoading,
    params: statsParams,
  } = useChainsPublicStats({ timeframe });

  const { processedChains } = useChainsSorting({
    blockchainsCountsMap: chainsCountsMap,
    chains,
    searchContent,
    sortType,
    timeframe,
    isPublicChainsChecked,
  });

  return {
    chains,
    loading: chainsLoading || statsLoading,
    processedChains,
    searchContent,
    setSearchContent,
    setSortType,
    sortType,
    statsParams,
    timeframe,
    isPublicChainsChecked,
    onPublicChainsCheckboxClick,
  };
};
